module.exports = __webpack_public_path__ + "img/06—01—Configuration.c6ac1ee7.jpg";